define('models/composer/forms/QuestionFactory',[
    'models/composer/forms/QuestionType',
    'models/composer/forms/MultipleChoiceQuestion',
    'services/loggingService'
], function (
    QuestionType,
    MultipleChoiceQuestionModel,
    LOG
) {
    'use strict';

    function QuestionFactory(data) {
        switch (data.type) {
            case QuestionType.multipleChoice:
              this.constructor = MultipleChoiceQuestionModel;
              return MultipleChoiceQuestionModel.apply(this, arguments);
            default:
              LOG.error('Unknown question type: ' + data.type);
              break;
        }
    }

    return QuestionFactory;
});

